import { render, staticRenderFns } from "./Dialog_tip.vue?vue&type=template&id=153fb3fa&scoped=true&"
import script from "./Dialog_tip.vue?vue&type=script&lang=js&"
export * from "./Dialog_tip.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_tip.vue?vue&type=style&index=0&id=153fb3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153fb3fa",
  null
  
)

export default component.exports